import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { City } from '@/http/models/City'
import type { MarketingPage } from '@/http/models/MarketingPage'
import type { MarketplaceEstablishment } from '@/http/models/MarketplaceEstablishment'
import type CategoryResource from '@/resources/CategoryResource'
import type { SlugType } from '@/enums/SlugType'

export const useMarketingPageStore = defineStore('ssr_marketing_page', () => {
  const page = ref<SlugType | null>(null)
  const city = ref<City | null>(null)
  const marketingPage = ref<MarketingPage | null>(null)
  const marketingRelated = ref()

  const categoryEstablishments = ref<MarketplaceEstablishment[]>()
  const categoryCategories = ref<[]>()
  const categoryCategory = ref<CategoryResource>()

  return {
    page,
    city,
    marketingPage,
    marketingRelated,
    categoryEstablishments,
    categoryCategories,
    categoryCategory,
  }
})
